<template>
    <div>
        <postal-upload-header page-name="郵便番号CSV(upload)" ></postal-upload-header>
        <postal-upload-content></postal-upload-content>

        <postal-file-select has-header :ext="['csv','CSV']" act="importPostalCsv"></postal-file-select>
    </div>
</template>

<script>
    import PostalUploadHeader from 'pages/commons/header/Header'
    import PostalUploadContent from './components/Content'
    import PostalFileSelect from 'pages/commons/file/File'

    export default {
        components: {
            PostalUploadHeader,
            PostalUploadContent,
            PostalFileSelect
        }
    }
</script>

<style></style>
